import React from "react";
import Header from "../../components/header/Header";
import Slider from "../../components/slider/SliderAnimation";
import About from "../../components/about/AboutAnimation";
import Portfolio from "../../components/portfolio/LiveMockupPortfolio";
import Contact from "../../components/contact/Contact";
import ContactInfo from "../../components/contact/ContactInfo";
import Map from "../../components/contact/Map";
import FunFacts from "../../components/funfacts/FunFacts";
import Partners from "../../components/partners/Partners";
import WhatsAppFloating from "../../components/contact/WhatsAppFloating";
import Footer from "../../components/footer/FooterAnimation";
import useDocumentTitle from "../../components/useDocumentTitle";
import Testimonials from "../../components/testimonial/TestimonialAnimation";
import Services from "../../components/service/ServiceAnimation";

const HomeOne = () => {
  useDocumentTitle(
    "Activo Digital || Desarrollo de Servicios en la Nube y Tecnología"
  );
  document.body.classList.add("theme-light");
  return (
    <div className="main-left">
      <Header />
      {/* End Header Section */}

      <main id="main-content">
        <Slider />
        {/* End Slider Section */}

        <About />
        {/* End About Section */}

        {/* Services Section */}
        <section id="servicios" className="section theme-light">
          <div className="container">
            <div className="title">
              <h2 className="h3">Servicios</h2>
            </div>
            <Services />
          </div>
        </section>
        {/* End Services Section */}

        {/* FunFacts & Partners Section */}
        <section id="por-que-elegirnos" className="section theme-light dark-bg">
          <div className="container">
            <div className="title">
              <h2 className="h3">Por qué elegirnos</h2>
            </div>
            <FunFacts />

            {/* separated */}
            <div
              className="separated"
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL + "img/border-dark.png"
                  })`,
              }}
            ></div>
            {/* End separated */}

            <Partners />
          </div>
        </section>
        {/* End FunFacts & Partners Section */}

        {/* Portfolio Section */}
        <section id="portafolio" className="section">
          <div className="container">
            <div className="title">
              <h2 className="h3">Portafolio.</h2>
            </div>
            <Portfolio />
          </div>
        </section>
        {/* End Portfolio Section */}

        {/* Testimonials Section */}
        <section id="testimonios" className="section theme-light dark-bg">
          <div className="container">
            <div className="title">
              <h2 className="h3">Testimonios</h2>
            </div>
            <Testimonials />
          </div>
        </section>
        {/* End Testimonials Section */}

        {/* Contact Section */}
        <section id="contacto" className="section theme-light">
          <div className="container">
            <div className="row">
              <div
                className="col-lg-5 col-xl-4 m-15px-tb"
                data-aos="fade-right"
                data-aos-duration="1200"
              >
                <ContactInfo />
              </div>
              {/* End Contact info */}

              <div
                className="col-lg-7 ml-auto m-15px-tb"
                data-aos="fade-right"
                data-aos-duration="1200"
                data-aos-delay="200"
              >
                <div className="contact-form">
                  {/* <h4>Say Something</h4> */}
                  <Contact />
                </div>
              </div>
              {/* End contact form */}

              <div
                className="col-12"
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="300"
              >
                <Map />
                {/* End google-map */}
              </div>
              {/* End Col */}
            </div>
          </div>
        </section>
        {/* End Contact Section */}
      </main>

      <footer className="footer white">
        <div className="container">
          <Footer />
        </div>
      </footer>
      {/* End Contact Section */}
      <WhatsAppFloating />
    </div>
  );
};

export default HomeOne;
